import React from "react";
import PropTypes from "prop-types";

const Price = ({ price }) => {
  let normalizedPrice = price ? `${parseFloat(price.normalized_price)} / ${price.normalized_price_unit}` : "-";

  return (
    <tr class={price && !price.is_active && "table-danger"}>
      <td>{price && price.vendor_item_code ? price.vendor_item_code : "-"}</td>
      <td>{price && price.item_name ? price.item_name : "-"}</td>
      <td>{price && price.vendor_item_name ? price.vendor_item_name : "-"}</td>
      <td>{price && price.brand ? price.brand : "-"}</td>
      <td>{price && price.items_per_pack ? price.items_per_pack : "-"}</td>
      <td>{price && price.packs_per_case ? price.packs_per_case : "-"}</td>
      <td>{price && price.pack_size ? price.pack_size : "-"}</td>
      <td>{price && price.price ? parseFloat(price.price) : "-"}</td>
      <td>{price && price.unit ? (price.config_unit ? `${price.unit} (${price.config_unit})` : price.unit) : "-"}</td>
      <td>{normalizedPrice !== undefined ? normalizedPrice : "-"}</td>
      {price && !price.is_active && (
        <div className="price-inactive">{"This price is inactive due to a better offer from the same vendor in another list"}</div>
      )}
    </tr>
  );
};

const PricesList = ({ pricesList }) => {
  return (
    pricesList && (
      <tbody>
        {pricesList.map((price) => {
          return <Price price={price} key={price.id} />;
        })}
      </tbody>
    )
  );
};

PricesList.propTypes = {
  pricesList: PropTypes.array.isRequired,
};

export default PricesList;
